import React from "react";
import {useTranslation} from "next-i18next";
import Input from "../../search/input";
import Select from "../type/select";
import Unit from "../unit";

/**
 *
 * @returns {JSX.Element}
 * @constructor
 */
export default function General ({ type, code, manufacturer, productName, amount, quantity, unit })
{
    // init
    const { t } = useTranslation();

    // render
    return (
        <>
            {/* Type & Code */}
            <div className="row justify-content-center justify-content-lg-start mb-3">
                {/* Type */}
                <div className="col-12 col-sm-6 col-md-5 mb-3">
                    <label className={'mb-1'} htmlFor="type">{t('type')}</label>
                    <Select value={type} includeAll={false} />
                </div>

                {/* Code */}
                <div className="col-12 col-sm-6 col-md-5 mb-3">
                    <label className={'mb-1'} htmlFor="code">{t('code')}</label>
                    <input className="form-control" id="code" type="text" placeholder={t('code.placeholder')} name="code" defaultValue={code ?? ''} required={true} />
                </div>
            </div>


            {/* Manufacturer & Name */}
            <div className="row justify-content-center justify-content-lg-start mb-3">
                {/* Brand */}
                <div className="position-relative col-12 col-sm-6 col-md-5 mb-3">
                    <label className={'mb-1'} htmlFor="manufacturer">{t('producer')}</label>
                    <Input
                        name={null}
                        type={'brand'}
                        placeholder={t('producer')}
                        required={true}
                        multiple={false}
                        defaultValue={manufacturer ?? ''}
                        loadOnChoose={false}
                    />
                </div>

                {/* Name */}
                <div className="col-12 col-sm-6 col-md-5 mb-3">
                    <label className={'mb-1'} htmlFor="productname">{t('product.name')}</label>
                    <input className="form-control" id="productname" type="text" placeholder={t('product.name')} name="name" defaultValue={productName ?? ''} required={true} />
                </div>
            </div>

            {/* Quanitity & Unit */}
            <div className="row justify-content-center justify-content-lg-start mb-3">
                {/* amount */}
                <div className="col-5 col-sm-2 mb-3">
                    <label className={'mb-1'} htmlFor="amount">{t('amount')}</label>
                    <input className="form-control" id="amount" type="number" min={1} max={999} step={1} placeholder={t('amount')} name="amount" defaultValue={amount ?? ''} required={true} />
                </div>

                {/* mulitplier */}
                <div className="col-2 col-sm-1 d-flex align-items-end justify-content-center mb-3">
                    <span className={'text-center m-0 mb-2'}>X</span>
                </div>

                {/* quantity */}
                <div className="col-5 col-sm-3 col-md-2 mb-3">
                    <label className={'mb-1'} htmlFor="quantity">{t('quantity')}</label>
                    <input className="form-control" id="quantity" type="number" min={0.01} max={999.99} step={0.01} placeholder={t('quantity')} name="quantity" defaultValue={quantity ?? ''} required={true} />
                </div>

                {/* Unit */}
                <div className="position-relative col-12 col-sm-6 col-md-5 mb-3">
                    <label className={'mb-1'} htmlFor="unit">{t('unit')}</label>
                    <Unit value={unit ?? ''} />
                </div>
            </div>
        </>
    );
}